import React from 'react'
import Panel from '../../../../../components/Panel'
import { IncentivePlanAuditEntry } from '../../../../../apis/types'
import { formatDateTime } from '../../../../../util/string'
import { normalizeActorName } from './incentiveDisplay'

interface IncentiveActivityLogPanelProps {
    auditHistory: IncentivePlanAuditEntry[]
    isLoading: boolean
}

const IncentiveActivityLogPanel: React.FC<IncentiveActivityLogPanelProps> = ({ auditHistory, isLoading }) => {
    return (
        <Panel header="Activity Log">
            <div className="overflow-x-auto">
                {isLoading ? (
                    <div className="animate-pulse space-y-2 py-2">
                        {[...Array(4)].map((_, i) => (
                            <div key={i} className="flex gap-4 px-4 py-2">
                                <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/4" />
                                <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/4" />
                                <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/4" />
                                <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/4" />
                            </div>
                        ))}
                    </div>
                ) : auditHistory.length === 0 ? (
                    <p className="px-4 py-3 text-sm text-gray-500 dark:text-gray-400">No history available.</p>
                ) : (
                    <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700">
                        <thead className="bg-white dark:bg-slate-950">
                            <tr>
                                {['Action', 'User', 'Timestamp', 'Reason'].map((h) => (
                                    <th
                                        key={h}
                                        className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider dark:text-white"
                                    >
                                        {h}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
                            {auditHistory.map((entry, idx) => (
                                <tr key={idx} className="bg-slate-50 dark:bg-slate-950/50">
                                    <td className="px-4 py-3 text-sm font-medium dark:text-gray-200">{entry.action}</td>
                                    <td className="px-4 py-3 text-sm dark:text-gray-300">{normalizeActorName(entry.user) ?? '—'}</td>
                                    <td className="px-4 py-3 text-sm dark:text-gray-300">
                                        {formatDateTime(new Date(entry.timestamp))}
                                    </td>
                                    <td className="px-4 py-3 text-sm text-gray-500 dark:text-gray-400">
                                        {entry.reason ?? '—'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </Panel>
    )
}

export default IncentiveActivityLogPanel
